import React, {useEffect} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {ListNode, INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND} from "@lexical/list";
import {$getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND, UNDO_COMMAND, REDO_COMMAND} from "lexical";

const FORMATS = ['bold', 'italic', 'underline', 'strikethrough'];

const RichTextToolbarPlugin = () =>
{
    const [editor] = useLexicalComposerContext();
    const [activeFormats, setActiveFormats] = React.useState({});
    const [listType, setListType] = React.useState(null);
    const [alignment, setAlignment] = React.useState('left');

    useEffect(() => {
        return editor.registerUpdateListener(({editorState}) => {
            editorState.read(() => {
                const selection = $getSelection();
                if (!$isRangeSelection(selection)) return;

                const formats = {};
                FORMATS.forEach(f => { formats[f] = selection.hasFormat(f); });
                setActiveFormats(formats);

                const anchorNode = selection.anchor.getNode();
                const element = anchorNode.getKey() === 'root'
                    ? anchorNode
                    : anchorNode.getTopLevelElementOrThrow();

                if (element instanceof ListNode || element.getParent() instanceof ListNode) {
                    const listNode = element instanceof ListNode ? element : element.getParent();
                    setListType(listNode.getListType());
                } else {
                    setListType(null);
                }

                const formatType = element.getFormatType ? element.getFormatType() : 'left';
                setAlignment(formatType || 'left');
            });
        });
    }, [editor]);

    const btn = (title, active, onClick, content) => (
        <button
            key={title}
            type="button"
            title={title}
            className={'lexical-toolbar-btn' + (active ? ' active' : '')}
            onMouseDown={e => { e.preventDefault(); onClick(); }}
        >
            {content}
        </button>
    );

    const sep = key => <div key={key} className="lexical-toolbar-sep" />;

    const toggleList = type => {
        if (listType === type) {
            editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
        } else if (type === 'bullet') {
            editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
        } else {
            editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
        }
    };

    return (
        <div className="lexical-toolbar">
            {btn('Bold',        activeFormats.bold,          () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'bold'),          <b>B</b>)}
            {btn('Italic',      activeFormats.italic,        () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, 'italic'),        <i>I</i>)}
            {sep('sep1')}
            {btn('Bullet list',   listType === 'bullet',   () => toggleList('bullet'),   '•≡')}
            {sep('sep3')}
            {btn('Undo', false, () => editor.dispatchCommand(UNDO_COMMAND, undefined), '↩')}
            {btn('Redo', false, () => editor.dispatchCommand(REDO_COMMAND, undefined), '↪')}
        </div>
    );
}

export {RichTextToolbarPlugin};